var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasPageDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 226,
    viewBox: "0 0 178 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_7489)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 160,
    height: 208,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.5,
    width: 159,
    height: 207,
    rx: 5.5,
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 11V10.9979C168.495 9.69855 167.774 8.56446 166.695 7.77225C165.616 6.97982 164.15 6.50364 162.553 6.5H162.552L15.4483 6.5L15.4471 6.5C13.8498 6.50364 12.3843 6.97982 11.3049 7.77225C10.2259 8.56447 9.50549 9.69856 9.5 10.9979H9.5V11V23V23.5H10H168H168.5V23V11Z",
    fill: "#E5E8F5",
    stroke: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2402H24V18.4802H18V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12.2402H34V18.4802H28V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2402H44V18.4802H38V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 12.2402H113V18.4802H58V12.2402Z",
    fill: "#D0D4E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 107,
    width: 122,
    height: 8,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 123,
    width: 122,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 136,
    width: 98,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 149,
    width: 67,
    height: 5,
    fill: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 180,
    width: 122,
    height: 22,
    rx: 4,
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0313 195H56.1953V187H59.0547C59.8594 187 60.5521 187.16 61.1328 187.48C61.7135 187.798 62.1602 188.255 62.4727 188.852C62.7878 189.448 62.9453 190.161 62.9453 190.992C62.9453 191.826 62.7878 192.542 62.4727 193.141C62.1602 193.74 61.7109 194.199 61.125 194.52C60.5417 194.84 59.8438 195 59.0313 195ZM57.8867 193.551H58.9609C59.4609 193.551 59.8815 193.462 60.2227 193.285C60.5664 193.105 60.8242 192.828 60.9961 192.453C61.1706 192.076 61.2578 191.589 61.2578 190.992C61.2578 190.401 61.1706 189.918 60.9961 189.543C60.8242 189.168 60.5677 188.892 60.2266 188.715C59.8854 188.538 59.4648 188.449 58.9648 188.449H57.8867V193.551ZM71.5498 191C71.5498 191.872 71.3844 192.615 71.0537 193.227C70.7256 193.839 70.2777 194.306 69.71 194.629C69.1449 194.949 68.5094 195.109 67.8037 195.109C67.0928 195.109 66.4548 194.948 65.8896 194.625C65.3245 194.302 64.8779 193.835 64.5498 193.223C64.2217 192.611 64.0576 191.87 64.0576 191C64.0576 190.128 64.2217 189.385 64.5498 188.773C64.8779 188.161 65.3245 187.695 65.8896 187.375C66.4548 187.052 67.0928 186.891 67.8037 186.891C68.5094 186.891 69.1449 187.052 69.71 187.375C70.2777 187.695 70.7256 188.161 71.0537 188.773C71.3844 189.385 71.5498 190.128 71.5498 191ZM69.835 191C69.835 190.435 69.7503 189.958 69.5811 189.57C69.4144 189.182 69.1787 188.888 68.874 188.688C68.5693 188.487 68.2126 188.387 67.8037 188.387C67.3949 188.387 67.0381 188.487 66.7334 188.688C66.4287 188.888 66.1917 189.182 66.0225 189.57C65.8558 189.958 65.7725 190.435 65.7725 191C65.7725 191.565 65.8558 192.042 66.0225 192.43C66.1917 192.818 66.4287 193.112 66.7334 193.312C67.0381 193.513 67.3949 193.613 67.8037 193.613C68.2126 193.613 68.5693 193.513 68.874 193.312C69.1787 193.112 69.4144 192.818 69.5811 192.43C69.7503 192.042 69.835 191.565 69.835 191ZM74.3027 195L72.0137 187H73.8613L75.1855 192.559H75.252L76.7129 187H78.2949L79.752 192.57H79.8223L81.1465 187H82.9941L80.7051 195H79.0566L77.5332 189.77H77.4707L75.9512 195H74.3027ZM90.5908 187V195H89.1299L85.6494 189.965H85.5908V195H83.8994V187H85.3838L88.8369 192.031H88.9072V187H90.5908ZM91.9883 195V187H93.6797V193.605H97.1094V195H91.9883ZM105.27 191C105.27 191.872 105.104 192.615 104.773 193.227C104.445 193.839 103.997 194.306 103.43 194.629C102.865 194.949 102.229 195.109 101.523 195.109C100.813 195.109 100.174 194.948 99.6094 194.625C99.0443 194.302 98.5977 193.835 98.2695 193.223C97.9414 192.611 97.7773 191.87 97.7773 191C97.7773 190.128 97.9414 189.385 98.2695 188.773C98.5977 188.161 99.0443 187.695 99.6094 187.375C100.174 187.052 100.813 186.891 101.523 186.891C102.229 186.891 102.865 187.052 103.43 187.375C103.997 187.695 104.445 188.161 104.773 188.773C105.104 189.385 105.27 190.128 105.27 191ZM103.555 191C103.555 190.435 103.47 189.958 103.301 189.57C103.134 189.182 102.898 188.888 102.594 188.688C102.289 188.487 101.932 188.387 101.523 188.387C101.115 188.387 100.758 188.487 100.453 188.688C100.148 188.888 99.9115 189.182 99.7422 189.57C99.5755 189.958 99.4922 190.435 99.4922 191C99.4922 191.565 99.5755 192.042 99.7422 192.43C99.9115 192.818 100.148 193.112 100.453 193.312C100.758 193.513 101.115 193.613 101.523 193.613C101.932 193.613 102.289 193.513 102.594 193.312C102.898 193.112 103.134 192.818 103.301 192.43C103.47 192.042 103.555 191.565 103.555 191ZM107.45 195H105.638L108.399 187H110.579L113.337 195H111.524L109.521 188.828H109.458L107.45 195ZM107.337 191.855H111.618V193.176H107.337V191.855ZM117.136 195H114.3V187H117.159C117.964 187 118.657 187.16 119.237 187.48C119.818 187.798 120.265 188.255 120.577 188.852C120.892 189.448 121.05 190.161 121.05 190.992C121.05 191.826 120.892 192.542 120.577 193.141C120.265 193.74 119.815 194.199 119.229 194.52C118.646 194.84 117.948 195 117.136 195ZM115.991 193.551H117.065C117.565 193.551 117.986 193.462 118.327 193.285C118.671 193.105 118.929 192.828 119.101 192.453C119.275 192.076 119.362 191.589 119.362 190.992C119.362 190.401 119.275 189.918 119.101 189.543C118.929 189.168 118.672 188.892 118.331 188.715C117.99 188.538 117.569 188.449 117.069 188.449H115.991V193.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8847 81.7347H70.2523C70.0192 81.7484 69.7843 81.7564 69.5476 81.7564C63.0988 81.7564 57.8708 76.5081 57.8708 70.0343C57.8708 63.5604 63.0988 58.3121 69.5476 58.3121C70.2057 58.3121 70.8511 58.3669 71.4796 58.4721C72.7958 58.6924 74.1885 57.8791 74.5075 56.5833C76.7103 47.6346 84.761 41 94.3556 41C105.647 41 114.8 50.1891 114.8 61.5242C114.8 62.4268 114.742 63.3158 114.63 64.1877C114.516 65.0704 115.323 65.8626 116.213 65.8626C120.585 65.8626 124.129 69.4204 124.129 73.8093C124.129 78.1981 120.585 81.7559 116.213 81.7559C116.015 81.7559 115.819 81.7484 115.625 81.7342H112.598",
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-outside-1_29_7489",
    maskUnits: "userSpaceOnUse",
    x: 53.8708,
    y: 36,
    width: 71,
    height: 45,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 53.8708,
    y: 36,
    width: 71,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8847 78.7347H68.2523C68.0192 78.7484 67.7843 78.7564 67.5476 78.7564C61.0988 78.7564 55.8708 73.5081 55.8708 67.0343C55.8708 60.5604 61.0988 55.3121 67.5476 55.3121C68.2057 55.3121 68.8511 55.3669 69.4796 55.4721C70.7958 55.6924 72.1885 54.8791 72.5075 53.5833C74.7103 44.6346 82.761 38 92.3556 38C103.647 38 112.8 47.1891 112.8 58.5242C112.8 59.4268 112.742 60.3158 112.63 61.1877C112.516 62.0704 113.323 62.8626 114.213 62.8626C118.585 62.8626 122.129 66.4204 122.129 70.8093C122.129 75.1981 118.585 78.7559 114.213 78.7559C114.015 78.7559 113.819 78.7484 113.625 78.7342H110.598"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.2523 78.7347V76.7347C68.213 76.7347 68.1738 76.7358 68.1346 76.7381L68.2523 78.7347ZM113.625 78.7342L113.771 76.7395C113.722 76.736 113.674 76.7342 113.625 76.7342V78.7342ZM112.63 61.1877L110.646 60.9315L112.63 61.1877ZM69.4796 55.4721L69.8097 53.4995L69.4796 55.4721ZM72.5075 53.5833L70.5655 53.1053L72.5075 53.5833ZM73.8847 76.7347H68.2523V80.7347H73.8847V76.7347ZM68.1346 76.7381C67.9347 76.7499 67.7395 76.7564 67.5476 76.7564V80.7564C67.8291 80.7564 68.1037 80.7469 68.37 80.7312L68.1346 76.7381ZM67.5476 76.7564C62.2107 76.7564 57.8708 72.4108 57.8708 67.0343H53.8708C53.8708 74.6053 59.987 80.7564 67.5476 80.7564V76.7564ZM57.8708 67.0343C57.8708 61.6577 62.2107 57.3121 67.5476 57.3121V53.3121C59.987 53.3121 53.8708 59.4632 53.8708 67.0343H57.8708ZM67.5476 57.3121C68.0945 57.3121 68.6295 57.3577 69.1494 57.4447L69.8097 53.4995C69.0727 53.3762 68.3169 53.3121 67.5476 53.3121V57.3121ZM74.4495 54.0614C76.4387 45.9806 83.7078 40 92.3556 40V36C81.8142 36 72.982 43.2887 70.5655 53.1053L74.4495 54.0614ZM92.3556 40C102.535 40 110.8 48.2863 110.8 58.5242H114.8C114.8 46.0918 104.759 36 92.3556 36V40ZM110.8 58.5242C110.8 59.3408 110.748 60.1442 110.646 60.9315L114.613 61.4438C114.737 60.4874 114.8 59.5129 114.8 58.5242H110.8ZM114.213 64.8626C117.473 64.8626 120.129 67.5176 120.129 70.8093H124.129C124.129 65.3231 119.697 60.8626 114.213 60.8626V64.8626ZM120.129 70.8093C120.129 74.1009 117.473 76.7559 114.213 76.7559V80.7559C119.697 80.7559 124.129 76.2954 124.129 70.8093H120.129ZM114.213 76.7559C114.066 76.7559 113.919 76.7503 113.771 76.7395L113.48 80.7289C113.72 80.7465 113.965 80.7559 114.213 80.7559V76.7559ZM113.625 76.7342H110.598V80.7342H113.625V76.7342ZM110.646 60.9315C110.353 63.201 112.317 64.8626 114.213 64.8626V60.8626C114.355 60.8626 114.436 60.9176 114.481 60.9642C114.532 61.0172 114.647 61.1835 114.613 61.4438L110.646 60.9315ZM69.1494 57.4447C71.3762 57.8173 73.8522 56.4879 74.4495 54.0614L70.5655 53.1053C70.5478 53.1773 70.4866 53.2906 70.3245 53.3898C70.1577 53.4917 69.9649 53.5255 69.8097 53.4995L69.1494 57.4447Z",
    fill: "#4C6FFF",
    mask: "url(#path-15-outside-1_29_7489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.911 76.166H98.2737V63.5088C98.2737 62.6804 97.6021 62.0088 96.7737 62.0088H87.7848C86.9564 62.0088 86.2848 62.6804 86.2848 63.5088V76.1661L81.6422 76.1664C80.3662 76.1665 79.673 77.6584 80.4958 78.6337L81.2453 78.0013L80.4958 78.6337L91.0927 91.1936C91.6906 91.9023 92.7818 91.9042 93.3822 91.1976L104.054 78.6373C104.882 77.663 104.19 76.166 102.911 76.166Z",
    fill: "white",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_7489",
    x: 0,
    y: 0,
    width: 178,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_29_7489"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_7489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_7489",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPageDownload);
export default __webpack_public_path__ + "static/media/canvas_page_download.a608b02c0f442b0c89eaacfc71aef092.svg";
export { ForwardRef as ReactComponent };